var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 29.25,
    viewBox: "0 0 29.25 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-close-circle",
    "data-name": "Icon ion-close-circle",
    d: "M18,3.375A14.625,14.625,0,1,0,32.625,18,14.642,14.642,0,0,0,18,3.375ZM23.3,21.7A1.125,1.125,0,1,1,21.7,23.3l-3.7-3.7-3.7,3.7A1.125,1.125,0,0,1,12.7,21.7l3.7-3.7-3.7-3.7A1.125,1.125,0,0,1,14.3,12.7l3.7,3.7,3.7-3.7A1.125,1.125,0,0,1,23.3,14.3l-3.7,3.7Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#2cc3ff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeCrossIcon);
export default __webpack_public_path__ + "static/media/see-cross-icon.b7570c37e5af5acc8cde4f0deaa03021.svg";
export { ForwardRef as ReactComponent };